import { PORTFOLIO } from "../constants/userConstants";

export const getAllPortFolioData = (data) => {
  return { type: PORTFOLIO.GET_PORTFOLIO_DATA, payload: data };
};

export const addPortfolioData = (data) => {
  return { type: PORTFOLIO.ADD_PORTFOLIO_DATA, payload: data };
};
